import { memo } from 'react';
import { clsx } from 'clsx';
import { TextBlock } from '@library';
import styles from './SaleTag.module.css';

interface SaleTagProps {
    mini?: boolean;
}

const sale = 'Sale';

const SaleTag = memo(({ mini }: SaleTagProps) => {
    return (
        <TextBlock
            secondary={!mini}
            medium={!mini}
            caption={mini}
            bold={mini}
            center
            uppercase
            lineHeightAsFontSize
            color="white"
            className={clsx(styles.container, {
                [styles.mini]: mini,
            })}
        >
            {sale}
        </TextBlock>
    );
});

export default SaleTag;
